export default __webpack_public_path__ + "static/media/kitchen5-afterE-768w.f5495e1f.webp";